import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './Header';
import Brands from './Brands';
import Main from './Main';
import Opinions from './Opinions';
import PralkiPorady from './PralkiPorady';
import Footer from './Footer';
import pralka from './logo.svg'; // added washing machine image import
import Loading from './Loading';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // simulate a 2 second loading delay
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <Loading isSmall={false} />
    );
  }

  return (
    <div className="App">
      <Header />
      <Brands />
      <Main />
      <Opinions/>
      <PralkiPorady/>
      <Footer/>
    </div>
  );
}

export default App;
